import React, { useContext } from 'react';
import {
  StoreCard, Logo, Link, Button, Icon,
} from 'anf-core-react';
import ProductPageContext from '../../contexts/ProductPageContext';

export default function StoreCardDetails({
  addressLine,
  telephone,
  city,
  stateOrProvinceName,
  postalCode,
  name,
}) {
  const ProductPageState = useContext(ProductPageContext);
  const { tmntData } = ProductPageState;

  return (
    <StoreCard
      brand={ProductPageState.collectionData?.brand}
      firstLogo={<Logo kind={`${ProductPageState.collectionData?.brand}-stacked`} />}
      storeMap={<Link href="test">{tmntData.mapAndHours?.value}</Link>}
      storeName={name}
    >
      <div className="store-locator">
        <span className="location-icon">
          <Icon
            icon="location-outline"
            labelText="location icon"
            size="s"
          />
        </span>
        <div>
          <div className="store-address-container">
            <p className="store-address-line-1">
              {addressLine}
            </p>
            <p className="store-address-line-2">
              {`${city} ${stateOrProvinceName}, ${postalCode}`}
            </p>
            <p className="store-phone">
              {telephone}
            </p>
          </div>
        </div>
      </div>
      <Button
        brand={ProductPageState.collectionData?.brand}
        isFullWidth
        variant="tertiary-dark"
        classList="near-me-button"
      >
        {tmntData.selectAStore?.value}
      </Button>
    </StoreCard>
  );
}
